export default function useConfig() {
  /**
   * パスワードの検証パターン
   * @returns
   */
  function PASSWORD_REGEX(): RegExp {
    return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!-/:-@[-`{-~])[!-~]{8,32}$/;
  }
  /**
   * 漫画ビューアのURLテンプレートを返します.
   * 形式は「https://viewer-dev.spotwrite.site:9443/works/:workId/images」
   */
  function VIEWER_URL_TEMPLATE(): string {
    return process.env.VUE_APP_VIEWER_URL_TEMPLATE;
  }

  /**
   * 画像のURLテンプレートを返します.
   * 形式は「https://devcontent.spotwrite.site/:image」
   */
  function IMAGE_URL_TEMPLATE(): string {
    return process.env.VUE_APP_IMAGE_URL_TEMPLATE;
  }

  return {
    PASSWORD_REGEX,
    VIEWER_URL_TEMPLATE,
    IMAGE_URL_TEMPLATE,
  };
}
